import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';
import toast from 'react-hot-toast';
import { Mail, ArrowLeft } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error('Please enter your email'); return; }
    setLoading(true);
    try {
      await authAPI.forgotPassword(email);
      setSent(true);
    } catch {
      toast.error('Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">
          <h1>LinguaFlow</h1>
          <span>Reset Password</span>
        </div>

        {sent ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ fontSize: '2.5rem', marginBottom: '1rem' }}>📧</div>
            <h3 style={{ fontWeight: 700, marginBottom: '0.5rem', fontSize: '1rem' }}>Check your inbox</h3>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', lineHeight: 1.6, marginBottom: '1.5rem' }}>
              If <strong style={{ color: 'var(--text-primary)' }}>{email}</strong> is registered, you'll receive a reset link shortly.
            </p>
            <p style={{ color: 'var(--text-faint)', fontSize: '0.78rem', marginBottom: '1.5rem' }}>
              The link expires in 1 hour. Check your spam folder if you don't see it.
            </p>
            <Link to="/login" style={{ color: 'var(--accent-soft)', textDecoration: 'none', fontSize: '0.85rem', fontWeight: 600 }}>
              ← Back to Login
            </Link>
          </div>
        ) : (
          <>
            <p style={{ color: 'var(--text-muted)', fontSize: '0.85rem', marginBottom: '1.5rem', lineHeight: 1.6 }}>
              Enter your email address and we'll send you a link to reset your password.
            </p>
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email Address</label>
                <input
                  type="email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com"
                  autoFocus
                />
              </div>
              <button className="btn btn-primary" type="submit" disabled={loading}>
                {loading ? 'Sending…' : <><Mail size={14} /> Send Reset Link</>}
              </button>
            </form>
            <div className="auth-switch">
              <Link to="/login" style={{ color: 'var(--accent-soft)', textDecoration: 'none', fontSize: '0.85rem' }}>
                <ArrowLeft size={13} style={{ display: 'inline', marginRight: 4 }} />
                Back to Login
              </Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
